









































































































import Vue from "vue";
import Component from "vue-class-component";
import {firebaseAuth} from "@/plugins/firebase";
import {defaultUnauthorizedPage, router} from "@/plugins/router";
import {getPageTitle} from "@/js/router-utils";
import Messages from "@/components/Messages.vue";
import {NavigationGroup} from "@/components/Navigation";

@Component
export default class Navigation extends Vue {

    drawer: boolean = false;

    get links(): NavigationGroup[] {
        return [
            {
                links: [
                    {title: this.$t("components.navigation.providers") as string, to: {name: "providers"}},
                    {
                        title: this.$t("components.navigation.additional-ingredients-groups") as string,
                        to: {name: "additional-ingredients-groups-default"}
                    },
                    {
                        title: this.$t("components.navigation.menu-items") as string,
                        to: {name: "menu-items-default"}
                    },
                ]
            }
        ];
    }

    get messages(): Messages {
        return this.$inject("messages");
    }

    get title() {
        return getPageTitle(this.$route);
    }

    mounted() {
        this.drawer = this.$vuetify.breakpoint.mdAndUp;
    }

    async logout() {
        try {
            await firebaseAuth.signOut();
            await router.push(defaultUnauthorizedPage);
        } catch (e) {
            console.error(e);
            await this.messages.showError(this.$t("components.navbar.errors.failed-to-logout") as string);
        }
    }

}
